import {Component, Inject, Input} from 'ng-metadata/core';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {IStateParamsService} from "angular-ui-router";

@Component({
    selector: 'prm-search-explain',
    templateUrl: 'components/search/searchResult/explain/search-explain.html',
})

export class PrmSearchExplain {

    @Input() private explain: string;

    private lines;
    private header;
    private entries;
    private links;
    private baseUrl;
    private value;
    private hits;
	private isOtbRanking: boolean = false;
    private records;
    
    private fields;
    
    private testBaseUrls = [
                    		{'name':'schema', 'url':'searchSchemaGetters.jsp?func=getSchema'},
                    		{'name':'utils', 'url':'jaguarLuceneUtils.jsp'}
                    	];

    constructor(private configurationUtil: ConfigurationUtil,@Inject('$location') private $location: ng.ILocationService,
				@Inject('$stateParams') private $stateParams: IStateParamsService){
    	this.explain = this.explain.replace(/\[COMMA\]/g, ",");
    	console.log(this.explain);

    	this.parseUrlAttr();
		this.otbRanking = $stateParams['otbRanking'] === 'true' || false;
    	
    	this.determineLinks();
    	
    	if (this.isNoResults()){
    		this.lines = [];
    	} else if (this.isRecordExplain()){
    		this.lines = this.explain.split('@@@');
    		
    		this.parseHeader();
    		this.parseEntries();
    		
    	} else {
    		this.lines = this.explain.split('[NEWLINE]');
    		this.lines = this.lines.slice(1);
    	}
    	
    	if (this.isRecordIds()){
    		this.parseRecords();
    	}
    	
    	if (this.isStored()){
    		this.parseFields();
    	}
    }
    
    private determineLinks(){
    	var links = [];
    	if (this.value.includes('explaintree')){
    		links=[{'name':'table',
    				'url':this.value.replace('explaintree', '')}];
    		
    	} else if (this.isRecordExplain()) {
    		links=[{'name':'tree',
				'url':this.value + 'explaintree'}];
    	}
    	
    	links = links.concat([
    	                      	{'url':(this.isSuprima?'':'lucene'), 'name':'lucene'},
    							{'url':'nodb,jaguar_internal_src_id,100', 'name':'records'}, 
    							{'url':'dym', 'name':'did you mean'},
    							{'url':'nodb,all', 'name':'stored'}, 
    							{'url':'basis', 'name':'basis'},
    							{'url':'params', 'name':'params'}
    							]);

    	this.links = links;
    }
    
    private parseRecords(){
    	this.records = []; 
		for (var i=1; i<this.lines.length-1; i++){
			this.records.push(this.lines[i].split(',')[0]);
		}
		this.hits = this.lines[this.lines.length-1];
    }
    
    private parseFields(){
		var fields = {};
		for (var i=1; i<this.lines.length-1; i++){
			var line = this.lines[i];
			var splitBySemicolon = line.split(',');
			for (var j=0; j<splitBySemicolon.length; j++){
				var splitByColon = splitBySemicolon[j].split(":");
				if (splitByColon.length>1){
					if (!splitByColon[0].includes(' ')){
						if (splitByColon[0][0]==';'){
							fields[splitByColon[0].substr(1)] = 1;
						} else {
							fields[splitByColon[0]] = 1;
						}
					}
				}
			}
		}
    	this.fields = Object.keys(fields).sort();
    }
    
    private parseUrlAttr(){
    	var baseUrl = window.location.href;
    	var start = baseUrl.indexOf('explain=');
    	var next = baseUrl.indexOf('&', start);
    	if (next < 0){
    		next = baseUrl.length;
    	}
		if(this.isSuprima){
			this.value = baseUrl.substring(start).split('&')[0].split('4everPr1m0lucene')[1];
			this.baseUrl = baseUrl.substring(0, start-1) + baseUrl.substring(next) + "&explain=4everPr1m0lucene";
		}
		else{
			this.value = baseUrl.substring(start).split('&')[0].split('4everPr1m0')[1];
			this.baseUrl = baseUrl.substring(0, start-1) + baseUrl.substring(next) + "&explain=4everPr1m0";
		}
    }
    
    private parseHeader(){
    	var header = this.lines[0].replace(/]/g,'').split('[');
		this.header = {
				'record':header[1],
				'score':header[2],
				'place':header[3],
				'index':header[4],
				'id':header[5].split(' ')[0],
		}
    }
    
    private parseEntries(){
    	this.entries = [];
		for (var i=1; i<this.lines.length; i++){
			try {
				//Examples:
				//TermQuery//[1.4300166E-4 = weight(sub:war^2.5 in 55226)]//[2.860033E-4=queryWeight(sub:war^2.5)] //[0.5=fieldWeight(sub:war in 55226)] //idf(docFreq=2372, maxDocs=262779)//tf(termFreq(sub:war)=1)//idf(docFreq=2372, maxDocs=262779)
				//PhraseQuery//[1.868166E-5 = weight(spanNear([spanNear([title:american, title:women], 0, true), title:world, title:war], 2147483647, true)^0.05 in 55226)]//[2.2880266E-5=queryWeight(spanNear([spanNear([title:american, title:women], 0, true), title:world, title:war], 2147483647, true)^0.05)] //[0.8164966=fieldWeight(title:spanNear([spanNear([american, women], 0, true), world, war], 2147483647, true)^0.05 in 55226)] //idf(title:  war=1397 american=4770 women=1437 world=2532)//tf(phraseFreq=0.16666667)//idf(title:  war=1397 american=4770 women=1437 world=2532)
    			var line = this.lines[i].replace(/\/\/|;|,/g,'(').replace(/\[|\]|\)/g,'');
    			var parts = line.split('(');
    			
    			var entry = {};
    			entry['qType'] = parts[0]; 
    			entry['boost'] = '1';
    			var spanNear = {'spanNear':1,'':1};
    			var isSpan = false;
    			
    			for (var j=1; j<parts.length; j++){
    				var part = parts[j]; 
    				if (part=='spanNear'){
    					entry['qType'] = 'SpanNear';
    					isSpan = true;
    					continue;
    				}
    				if (part.startsWith(' true^') || part.startsWith(' false^')){
    					entry['boost'] = part.split('^')[1].split(' ')[0];
    				}
    					
    				var splitByEquals = part.split('=');
    				
    				if (splitByEquals.length==2){
    					if (splitByEquals[0].includes(':') || splitByEquals[0].includes('termFreq')){
    						splitByEquals[0] = 'tf';
    					}
    					splitByEquals[0] = splitByEquals[0].trim();
    					splitByEquals[1] = splitByEquals[1].trim();
    					if (!isNaN(splitByEquals[0])){
    						entry[splitByEquals[1]] = splitByEquals[0];
    					} else if (!isNaN(splitByEquals[1])){
    						entry[splitByEquals[0]] = splitByEquals[1];
    					} else {
    						entry['tf'] = splitByEquals[1].split(' ')[0];
    					}
    				} else {
    					var splitByColon = parts[j].split(':');
    					if (splitByColon.length==2 && splitByColon[1].trim() !== ''){
    						entry['field'] = splitByColon[0];
    						var splitByCaret = splitByColon[1].split('^');
    						if (splitByCaret[0].startsWith('"')){
    							if (splitByCaret[0].includes('~')){
    								entry['qType'] = "SlopQuery";
    							}
    							var term = splitByCaret[0].substr(0, splitByCaret[0].indexOf('"',2)+1);
    							if (isSpan && ('term' in entry)){
    								if (!(term in spanNear)){
    									entry['term'] += (', ' + term);
    								}
    							} else {
    								entry['term'] = term;
    							}
    							if (isSpan){
    								spanNear[term] = 1;
    							}
    							
    						} else {
    							var term = splitByCaret[0].split(' ')[0];
    							if (isSpan && ('term' in entry)){
    								if (!(term in spanNear)){
    									entry['term'] += (', ' + term);
    								}
    							} else if (!('term' in entry)){
    								entry['term'] = term;
    							} 
    							if (isSpan){
    								spanNear[term] = 1;
    							}
    						}
    						
    						if (splitByCaret.length > 1){
    							entry['boost'] = splitByCaret[1].split(' ')[0];
    						}
    					}
    				}
    			}
			} catch(err) {
				console.log(err);
			}
			console.log(entry);
			this.entries.push(entry);
		}
    }
    
    getFields(){
    	return this.fields;
    }
    
    getRecords(){
    	return this.records;
    }
    
    getLinks(){
    	return this.links;
    }
    
    getEntries(){
    	return this.entries;
    }
    
    getLines(){
    	return this.lines;
    }
    
    getTestUrl(){
    	return window.location.protocol + "//" + window.location.host + '/primo_library/libweb/test/';
    }
    
    isNoResults(){
    	return this.explain==='No Results';
    }
    
    isStored(){
    	return this.value.startsWith('nodb,all');
    }
    
    isParams(){
    	return this.value==='params';
    }
    
    isRecordIds(){
    	return this.value.startsWith('nodb,jaguar_internal_src_id,');
    }
    
    isRecordExplain(){
    	return this.explain.length > 20 && !this.explain.startsWith('[NOT_EXPLAIN]');
    }

    get isSuprima() {
        return this.configurationUtil.isSuprima();

    }

	public get otbRanking(){
		return this.isOtbRanking;
	}

	set otbRanking(otbRanking) {
		this.isOtbRanking = otbRanking;
	}

	public changeRanking() {
		let mode = this.isOtbRanking ? 'true' : 'false';
		this.$location.search('otbRanking', mode);
	}

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/explain/searchExplain.directive.ts